// Event emitter for wallet connection modal
class WalletModalEmitter extends EventTarget {
  showModal() {
    this.dispatchEvent(new CustomEvent('showWalletModal'));
  }

  hideModal() {
    this.dispatchEvent(new CustomEvent('hideWalletModal'));
  }
}

export const walletModalEmitter = new WalletModalEmitter();
